<template>
  <div class="sidepanel-options">
    <div class="sidepanel-separator"></div>
    <template v-if="0 || !isEvent">
      <div class="custom-answer text-panel-section-header mt-2">
        {{ $t('options.allowParticipantToAnswerWith') }}
      </div>

      <ToggleOption
        v-model="mayBeAnswers"
        :disabled="mayBeAnswerDisabled"
        icon="edit"
        class="my-2"
      >
        <div class="d-flex toggle-option">
          <div class="toggle-icon checked">
            (
            <font-awesome-icon :icon="['fas', 'check']" />
            )
          </div>

          <span>
            {{ $t('options.ifNeededBe') }}
          </span>
        </div>
      </ToggleOption>

      <ToggleOption v-model="allowDoNotKnowAnswer" icon="edit" class="my-2">
        <div class="d-flex toggle-option">
          <div class="toggle-icon">
            <font-awesome-icon :icon="['fas', 'question']" />
          </div>

          <span>
            {{ $t('options.doNotKnowYet') }}
          </span>
        </div>
      </ToggleOption>
    </template>

    <div
      v-if="(isAdmin || isBeta) && !isEvent"
      class="d-flex pointer logo-manager-parent mt-2"
      @click="openConfigureAnswer"
    >
      <div class="d-flex flex-column justify-content-center">
        <span class="text-weight-semi-bold">
          {{ $t('configureAnswer.firstDescription') }}
          <label class="col-2 col-form-label new-premium-label">
            {{ $t('options.new') }}
          </label>
          <img
            class="ml-1 mr-2 flex-column border-radius premium-logo-design"
            height="50"
            srcset="/images/PremiumFavicon.png"
            alt=""
          />
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('configureAnswer.secondDescription') }}
        </div>
      </div>
      <!-- End of label part -------- -->

      <!-- ----- End of Drop down part--- -->
      <div class="a-self logo-image-update flex-column">
        <img
          v-if="0"
          class="ml-auto mr-2 flex-column border-radius custom-logo-image"
          height="50"
          srcset="../../assets/logo_neu_weiss_blau_orange.png 2x"
          alt=""
        />
        <icon class="h3 text-primary mt-1" type="nextButton" />
      </div>
    </div>

    <div v-if="!isEvent" class="sidepanel-separator"></div>

    <ToggleOption
      v-if="isEvent"
      v-model="limitedVotesPerEvent"
      icon="edit"
      :separator="false"
      class="my-2 limited-votes"
    >
      <span class="text-weight-semi-bold">
        {{ $t('options.limitedVotesPerEvent') }}
      </span>
      <div class="text-size-10 pt-0 toggle-description">
        {{ $t('options.limitedVotesPerEventTip') }}
      </div>
      <template v-slot:value>
        <InputText v-if="limitedVotesPerEvent" label="" v-model="guestsLimit" />
      </template>
    </ToggleOption>

    <div v-if="isEvent" class="sidepanel-separator"></div>

    <template v-if="!isEvent">
      <ToggleOption
        v-model="setDefaultAsNoForNotAnswered"
        icon="edit"
        class="my-2"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.allowDefaultNoAnswer') }}
          <label class="col-2 col-form-label new-premium-label"> New </label>
        </span>

        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.allowDefaultNoAnswerDescription') }}
        </div>
      </ToggleOption>

      <div class="sidepanel-separator"></div>

      <ToggleOption
        v-model="limitedVotesPerChoice"
        icon="edit"
        :separator="false"
        class="my-2 limited-votes"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.limitedVotesPerChoice') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.limitedVotesPerChoiceTip') }}
        </div>
        <template v-slot:value>
          <InputText
            v-if="limitedVotesPerChoice"
            label=""
            v-model="votesLimit"
          />
        </template>
      </ToggleOption>

      <ToggleOption
        v-model="limitedVotesPerChoiceSpecific"
        icon="edit"
        :separator="false"
        class="my-2 limited-votes"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.limitedVotesPerChoiceSpecific') }}
          <img
            class="ml-1 mr-2 flex-column border-radius premium-logo-design"
            height="48"
            srcset="/images/PremiumFavicon.png"
            alt=""
          />
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.limitedVotesPerChoiceSpecificTip') }}
        </div>
      </ToggleOption>

      <div class="sidepanel-separator"></div>

      <ToggleOption v-model="oneChoicePerParticipant" icon="edit" class="my-2">
        <span class="text-weight-semi-bold">
          {{ $t('options.oneChoicePerParticipant') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.oneChoicePerParticipantTip') }}
        </div>
      </ToggleOption>

      <div class="sidepanel-separator"></div>
    </template>

    <!-- <div class="sidepanel-separator"></div> -->

    <ToggleOption
      v-if="0"
      v-model="showStatisticToParticipants"
      icon="edit"
      class="my-2"
    >
      <span class="text-weight-semi-bold">
        {{ $t('options.showStatisticToParticipants') }}
      </span>
      <div class="text-size-12 pt-1">
        {{ $t('options.showStatisticToParticipantsTip') }}
      </div>
    </ToggleOption>
    <div v-if="0" class="sidepanel-separator"></div>

    <ToggleOption v-model="allowComments" icon="edit" class="my-2">
      <span class="text-weight-semi-bold">
        {{ $t('options.allowComments') }}
      </span>

      <div class="text-size-10 pt-0 toggle-description">
        {{ $t('options.allowCommentsTip') }}
      </div>
    </ToggleOption>

    <div v-if="1">
      <div v-if="1" class="sidepanel-separator"></div>

      <ToggleOption v-model="allowTasks" icon="edit" class="my-2">
        <span class="text-weight-semi-bold">
          {{ $t('options.allowTasks') }}
          <!-- <label class="col-2 col-form-label new-premium-label"> New </label> -->
          <img
            class="ml-1 mr-2 flex-column border-radius premium-logo-design"
            height="50"
            srcset="/images/PremiumFavicon.png"
            alt=""
          />
        </span>

        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.allowTasksTip') }}
        </div>
      </ToggleOption>
    </div>
    <div v-if="1" class="sidepanel-separator"></div>

    <ToggleOption v-if="1" v-model="hiddenPoll" icon="edit" class="mt-1">
      <span class="text-weight-semi-bold">
        {{ $t('options.hiddenPoll') }}
      </span>
      <div class="text-size-12 pt-0">
        {{ $t('options.hiddenPollTip') }}
      </div>
    </ToggleOption>

    <ToggleOption
      v-if="hiddenPoll"
      v-model="showCounts"
      icon="edit"
      class="text-size-12"
    >
      <span class="text-weight-regular">
        {{ $t('options.showCounts') }}
      </span>
    </ToggleOption>

    <div v-if="1" class="sidepanel-separator mt-2"></div>

    <ToggleOption 
    v-if="!isEvent"
    v-model="bookingModePoll" icon="edit" class="mt-1">
      <span class="text-weight-semi-bold">
        {{ $t('options.bookingModePoll') }}
        <img
          class="ml-1 mr-2 flex-column border-radius premium-logo-design"
          height="50"
          srcset="/images/PremiumFavicon.png"
          alt=""
        />
      </span>
      <div class="text-size-12 pt-0">
        {{ $t('options.bookingModePollTip') }}
      </div>
    </ToggleOption>

    <div class="panel-section-header text-panel-section-header mt-2">
      {{ $t('options.sectionSubadmin') }}
      <img
        class="ml-1 mr-2 flex-column border-radius premium-logo-design"
        height="50"
        srcset="/images/PremiumFavicon.png"
        alt=""
      />
    </div>

    <div class="text-size-12">
      {{ $t('options.sectionSubadminDescription') }}
    </div>
    <div class="panel-section-header text-panel-section-header mt-2">
      {{ $t('options.sectionNotification') }}
    </div>

    <ToggleOption v-model="notifyOnNewAnswer" icon="edit" class="my-2">
      <span class="text-weight-semi-bold">
        {{ $t('options.notifyOnNewAnswer') }}
      </span>
      <div class="text-size-10 pt-0 toggle-description">
        {{ $t('options.notifyOnNewAnswerTip') }}
      </div>
    </ToggleOption>
    <div v-if="1" class="sidepanel-separator"></div>
    <ToggleOption v-model="notifyOnNewUser" icon="edit" class="my-2">
      <span class="text-weight-semi-bold">
        {{ $t('options.notifyOnNewUser') }}
      </span>
      <div class="text-size-10 pt-0 toggle-description">
        {{ $t('options.notifyOnNewUserTip') }}
      </div>
    </ToggleOption>
  </div>
</template>
<script>
import ToggleOption from '@/components/Edit/ToggleOption.vue';
import InputText from '@/components/UI/InputText.vue';

import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { dateMixin } from '@/components/mixins/DateMixins.js';
import { renderMixin } from '../mixins/RenderMixins';
import { constants } from '@/shared/constant';

import { mapState, mapGetters } from 'vuex';
import Icon from '../UI/Icon.vue';

import { version } from '@/../../package';
import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

import moment from 'moment';
// import CustomBrandingTemplates from './CustomBrandingTemplates.vue';

extend('required', required);
localize('en', en);

export default {
  name: 'EditKulibri',

  props: ['backup'],
  mixins: [formValidationMixin, dateMixin, renderMixin],

  components: {
    ToggleOption,
    InputText,

    Icon,

    // CustomBrandingTemplates
  },

  data() {
    const hSpacing = '15px';

    return {
      localDetails: null,
      ownerUser: null,
      showConfirm: false,
      buildVersion: version,
      disable: false,
      displayScroll: false,
      showDeadlinePicker: false,
      backupDeadline: null,
      pollDeadline: null,
      numberOfDaySelection: [],
      autoReminderDeadlineOption: '',

      themeStyles: {
        wrapper: {
          background: 'linear-gradient(to bottom right, #ff5050, #ff66b3)',
          color: '#fafafa',
          border: '0',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: '5px',
        },
        header: {
          padding: `20px ${hSpacing}`,
        },
        headerHorizontalDivider: {
          borderTop: 'solid rgba(255, 255, 255, 0.2) 1px',
          width: '80%',
        },
        weekdays: {
          color: '#6eded1', // New color
          fontWeight: '600', // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
        },
        dayContent: {
          fontSize: '0.9rem',
        },
      },
      dialogContent: {
        title: '',
        description: '',
        cancelLabel: '',
        okLabel: '',
      },
      diplayReminderDetails: false,
      diplayAppearanceDetails: false,
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      ownerId: (state) => state.poll.poll.user.id,
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      userName: 'userName',
      isAuthenticated: 'isAuthenticated',
      currentParticipantName: 'currentParticipantName',
      isAdmin: 'isAdmin',
      isPremium: 'isPremium',
      isBeta: 'isBeta',
      getSelectedTemplate: 'getSelectedTemplate',
      designs: 'designs',
    }),

    backgroundImageThumnail() {
      return '/images/background_default_thumnail.jpg';
    },

    locale() {
      return this.$store.getters.userLocale;
    },

    timezone() {
      return '';
    },

    deadline() {
      if (!this.pollDeadline) return this.$t('options.noDeadline') + ' ';

      // let deadline = this.fullWeekDay(this.pollDeadline) + ' ';
      // deadline += this.dayMonthYear(this.pollDeadline);
      const locale = this.$i18n.locale;
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Date(this.poll.deadline).toLocaleString(locale, options);
    },
    /* get formated dealine for reminder -> radio btton -> before dealine  */
    deadlineForReminder() {
      try {
        if (!this.pollDeadline) return this.$t('automateReminder.notSet'); // date not found than reurn default message (not set)
        return moment(String(this.pollDeadline)).format(
          this.$t('automateReminder.dateFomatForUI')
        ); //format date to dd.mm.yyyy and return
      } catch (error) {
        console.error(error);
        return '';
      }
    },

    /** get formated date from polls choice for rediobutton ->  before next date option*/
    beforeNextDateForReminder() {
      try {
        if (this.poll && this.poll.type && this.poll.type != 1)
          return this.$t('automateReminder.availableInDatePollOnly');
        if (this.pollDeadline) return this.$t('automateReminder.notAvailable'); // date not found than reurn default message (not available)
        let _days;
        if (this.poll.delay_interval) {
          _days = this.poll.delay_interval;
          _days = _days.sort((a, b) => b - a);
        }
        /** if poll date found than return first date by substract days */
        if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
          let todayDate = moment(new Date()).format(
            this.$t('automateReminder.dateFomatForUI')
          );
          for (let i = 0; i < this.poll.choices.length; i++) {
            if (this.poll.choices[i].start) {
              for (
                let deadlineIndex = 0;
                deadlineIndex < _days.length;
                deadlineIndex++
              ) {
                let date = moment(String(this.poll.choices[i].start))
                  .subtract(_days[deadlineIndex], 'days')
                  .format(this.$t('automateReminder.dateFomatForUI')); //substtract by largest days and format
                if (date >= todayDate) {
                  return moment(this.poll.choices[i].start).format(
                    this.$t('automateReminder.dateFomatForUI')
                  );
                }
              }
            }
          }
        }
        return this.$t('automateReminder.notAvailable');
      } catch (error) {
        console.error(error);
        return this.$t('automateReminder.notAvailable');
      }
    },

    /* enable or disable automatedReminder days ->  check boxs*/
    isDisableChoices() {
      try {
        if (!this.isPremium || !this.pollDeadline) return true;

        // let choice = null;
        // if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        //   choice = this.poll.choices
        // }
        // if(!this.pollDeadline && !choice || choice == null)  return true;

        return false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    /** disable  -> redio button -> before dealine */
    isDisableBeforeDealine() {
      if (!this.isPremium) return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (!this.pollDeadline && (!choice || choice == null)) return true;

      if (choice && choice.length > 0 && !this.pollDeadline) return true;

      return false;
    },
    /* disable -> radio btton -> before next date option */
    isDisableBeforeNextDateOption() {
      if (
        !this.isPremium ||
        (this.poll && this.poll.type && this.poll.type != 1)
      )
        return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (
        (!this.pollDeadline && (!choice || choice == null)) ||
        (choice && choice.length > 0 && this.pollDeadline)
      ) {
        return true;
      }

      return false;
    },

    btnLabelAdddeadline() {
      if (this.pollDeadline) {
        return this.$t('general.change');
      }
      return this.$t('general.add');
    },

    mayBeAnswerDisabled() {
      if (this.poll.options.limitedVotesPerChoice) return true;
      if (this.poll.options.oneChoicePerParticipant) return true;
      return false;
    },

    isEvent() {
      if (this.type == 2) return true;
      return false;
    },

    adminUrl() {
      let adminKey =
        this.ownerId.substring(this.ownerId.length - 4) + this.ownerId;
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        adminKey;
      return url;
    },

    invitations() {
      return this.poll.invitations;
    },

    invitationUrl() {
      let url = process.env.VUE_APP_FRONTEND_URI + '/pr/' + this.poll.id + '/';
      return url;
    },

    title: {
      get() {
        return this.poll.title;
      },
      set(value) {
        this.$store.commit('updateTitle', value);
        this.validateForm();
      },
    },

    type: {
      get() {
        return this.poll.type;
      },
      set(value) {
        this.$store.commit('updateType', value);
      },
    },

    description: {
      get() {
        return this.poll.description;
      },
      set(value) {
        this.$store.commit('updateDescription', value);
      },
    },

    name: {
      get() {
        console.log('name-->', this.ownerUser, this.user);
        if (this.ownerUser == null) {
          if (this.user) return this.user.name;
        }
        return this.ownerUser.name;
      },
      set(value) {
        this.ownerUser.name = value;
        this.$store.commit('updateName', value);
      },
    },

    email: {
      get() {
        if (this.ownerUser == null) {
          if (this.user) return this.user.email;
        }
        return this.ownerUser.email;
      },
      set(value) {
        this.ownerUser.email = value;
        this.$store.commit('updateEmail', value);
      },
    },

    mayBeAnswers: {
      get() {
        return this.poll.options.mayBeAnswers;
      },
      set(value) {
        this.$store.commit('updateMayBeAnswers', value);
      },
    },

    limitedVotesPerChoice: {
      get() {
        return this.poll.options.limitedVotesPerChoice;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
          this.poll.options.limitedVotesPerChoiceSpecific = false;
        }
        this.$store.commit('updateLimitedVotesPerChoice', value);
      },
    },

    limitedVotesPerChoiceSpecific: {
      get() {
        return this.poll.options.limitedVotesPerChoiceSpecific;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
          this.poll.options.limitedVotesPerChoice = false;
          this.poll.choices.forEach((c) => (c.limit = null));
        } else {
          this.poll.choices.forEach((c) => (c.limit = null));
        }
        this.$store.commit('updateLimitedVotesPerChoiceSpecific', value);
      },
    },

    limitedVotesPerEvent: {
      get() {
        return this.poll.options.limitedVotesPerEvent;
      },
      set(value) {
        this.$store.commit('updateLimitedVotesPerEvent', value);
      },
    },

    votesLimit: {
      get() {
        return this.poll.options.votesLimit;
      },
      set(value) {
        console.log('updateVotesLimit');
        this.$store.commit('updateVotesLimit', value);
      },
    },
    guestsLimit: {
      get() {
        return this.poll.options.guestsLimit;
      },
      set(value) {
        console.info('updateGuestsLimit', value);
        if (value != '' && value <= 0) {
          this.$nextTick(() => {
            value = 1;
            this.poll.options.guestsLimit = 1;
          });
        }
        if (value == '') value = 1;
        this.$store.commit('updateGuestsLimit', value);
      },
    },

    darkMode: {
      get() {
        if (this.poll.options.darkMode == null) return false;
        return this.poll.options.darkMode;
      },
      set(value) {
        if (this.designs.length == 0) {
          this.loadDesign().then(() => {
            this.$store.commit('updateDarkMode', value);
            this.updateDesignTemplate(value);
          });
        } else {
          this.$store.commit('updateDarkMode', value);
          this.updateDesignTemplate(value);
        }
      },
    },

    oneChoicePerParticipant: {
      get() {
        return this.poll.options.oneChoicePerParticipant;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
        }
        this.$store.commit('updateOneChoicePerParticipant', value);
      },
    },

    showStatisticToParticipants: {
      get() {
        return this.poll.options.showStatisticToParticipants;
      },
      set(value) {
        console.log('ShowStatisticToParticipants set:', value);
        this.$store.commit('updateShowStatisticToParticipants', value);
      },
    },

    allowComments: {
      get() {
        return this.poll.options.allowComments;
      },
      set(value) {
        this.$store.commit('updateAllowComments', value);
      },
    },

    allowTasks: {
      get() {
        return this.poll.options.allowTasks;
      },
      set(value) {
        this.$store.commit('updateAllowTasks', value);
      },
    },

    hiddenPoll: {
      get() {
        return this.poll.options.hiddenPoll;
      },
      set(value) {
        this.$store.commit('updateHiddenPoll', value);
      },
    },

    bookingModePoll: {
      get() {
        return this.poll.options.bookingModePoll;
      },
      set(value) {
        this.$store.commit('updateBookingModePoll', value);
      },
    },

    notifyOnNewAnswer: {
      get() {
        return this.poll.options.notifyOnNewAnswer;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewAnswer', value);
      },
    },

    notifyOnNewUser: {
      get() {
        return this.poll.options.notifyOnNewUser;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewUser', value);
      },
    },

    showCounts: {
      get() {
        return this.poll.options.showCounts;
      },
      set(value) {
        this.$store.commit('updateShowCounts', value);
      },
    },

    delayInterval: {
      get() {
        return this.poll.delay_interval || [];
      },
      set(value) {
        this.$store.commit('updateDelayInterval', value);
      },
    },

    delayType: {
      get() {
        if (this.poll.delay_type) {
          return this.poll.delay_type;
        }
        return null;
      },
      set(value) {
        this.$store.commit('updateDelayType', value);
      },
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },

    isAnonymousUser() {
      if (this.poll.user.email == 'dummy@kulibri.com') {
        return true;
      }
      return false;
    },

    header() {
      if (this.isNewPoll) {
        return this.$t('create.dlgHeaderNew');
      }
      return this.$t('create.dlgHeaderEdit');
    },

    saveText() {
      // if (this.isNewPoll) {
      //   return this.$t('create.dlgSaveNew');
      // }
      // return this.$t('create.dlgSaveDone');
      if (this.poll.type == 2) {
        // if event
        if (this.isNewPoll) {
          return this.$t('create.dlgContinue');
        }
        return this.$t('create.dlgSaveDone');
      }
      return this.$t('create.dlgSaveNew');
    },

    cancelText() {
      return this.$t('create.dlgCancel');
    },

    getCustomClass() {
      return this.displayScroll
        ? 'descriptionTextarea descriptionTextareaScroll'
        : 'descriptionTextarea';
    },

    getDescriptionLength() {
      return (
        (this.description ? this.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
    setDefaultAsNoForNotAnswered: {
      get() {
        return this.poll.options.setDefaultAsNoForNotAnswered;
      },
      set(value) {
        this.$store.commit('setDefaultAsNoForNotAnswered', value);
      },
    },
    allowDoNotKnowAnswer: {
      get() {
        return this.poll.options.allowDoNotKnowAnswer;
      },
      set(value) {
        this.$store.commit('updateAllowDoNotKnowAnswer', value);
      },
    },
  },

  watch: {
    delayInterval: {
      deep: true,
      handler: function () {
        this.delayType =
          this.pollDeadline && this.delayInterval.length > 0
            ? 'before_deadline'
            : null;
      },
    },
  },

  methods: {
    openConfigureAnswer() {
      this.$emit('openConfigureAnswer');
    },
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';
// input.form-control:focus {
//   box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
//     0 0 0px rgba(126, 239, 104, 0.6);
//   outline: 0 none;
// }

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.mr-10 {
  margin-right: 10px !important;
}

.backgroundButton {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.logo-manager-parent {
  cursor: pointer;
  justify-content: space-between;
  .logo-image-update {
    display: block;
  }
  // label, button {
  //   word-break: break-word;
  //   white-space: normal;
  //   width: 100px;
  //   color: $primary;
  // }
}

.reminder-in-days {
  justify-content: space-between;
}

.custom-answer {
  color: $dark-grey;
}

.toggle-option {
  .toggle-icon {
    border: 1px solid $dark-grey;
    padding: 6px;
    border-radius: 5px;
    width: 48px;
    height: 36px;
    text-align: center;
  }
  .checked {
    color: $secondary;
  }
  span {
    margin-left: 5px;
    margin-top: auto;
    margin-bottom: auto;
  }
}
</style>
